(function () {
	'use strict';

	angular
		.module('app.setup')
		.service('configSSOService', configSSOService);

	configSSOService.$inject = ['$http', 'URLS'];
	

	function configSSOService($http, URLS, tls, net) {
		
		var service = {
			disableSamlProfile: disableSamlProfile,
			activateSamlProfile: activateSamlProfile,
			deleteSamlProfile: deleteSamlProfile,
			getSamlProfile: getSamlProfile,
			updateSamlProfile: updateSamlProfile,
			createSamlProfile: createSamlProfile,
			toggleLegacyEntityID: toggleLegacyEntityID
		};
		return service;

	

		function disableSamlProfile(samlProfileId) {
			var samlConfigURL = URLS.host + String.format(URLS.samlConfigURL, globalConfig.customer.id)+ '/' + samlProfileId + '/disable';
			return $http.put(samlConfigURL)
				.then(disableSamlProfileSuccess, handleError);

			function disableSamlProfileSuccess(response) {
				return 'SAML Profile disabled successfully';
			}
		}

		function deleteSamlProfile(samlProfileId) {
			var samlConfigURL = URLS.host + String.format(URLS.samlConfigURL, globalConfig.customer.id)+ '/' + samlProfileId ;
			return $http.delete(samlConfigURL)
				.then(deleteSamlProfileSuccess, handleError);

			function deleteSamlProfileSuccess(response) {
				return 'SAML Profile deleted successfully';
			}
		}

		function activateSamlProfile(samlProfileId) {
			var samlConfigURL = URLS.host + String.format(URLS.samlConfigURL, globalConfig.customer.id)+ '/' + samlProfileId + '/activate';
			return $http.put(samlConfigURL)
				.then(activateSamlProfileSuccess, handleError);

			function activateSamlProfileSuccess(response) {
				return 'SAML Profile activated successfully';
			}
		}

		function toggleLegacyEntityID(samlProfileId) {
			var samlConfigURL = URLS.host + String.format(URLS.samlConfigURL, globalConfig.customer.id)+ '/' + samlProfileId + '/toggleLegacyEntityID';
			return $http.put(samlConfigURL)
				.then(toggleLegacyEntityIDSuccess, handleError);

			function toggleLegacyEntityIDSuccess(response) {
				return 'Legacy EntityID toggled successfully';
			}
		}

		function getSamlProfile(samlProfileId) {
			var samlConfigURL = URLS.host + String.format(URLS.samlConfigURL, globalConfig.customer.id)+ '/' + samlProfileId ;
			return $http.get(samlConfigURL)
				.then(getSamlProfileSuccess, handleError);

			function getSamlProfileSuccess(response) {
				return response.data;
			}
		}

		function updateSamlProfile(samlProfile, dateModified, samlProfileId) {
			var samlConfigURL = URLS.host + String.format(URLS.samlConfigURL, globalConfig.customer.id)+ '/' + samlProfileId ;
			return $http.put(samlConfigURL, samlProfile, { headers: { 'If-Unmodified-Since': dateModified } })
				.then(updateSamlProfile, handleError);

			function updateSamlProfile(response) {
				return response;
			}
		}

		function createSamlProfile(samlProfile) {
			var samlConfigURL = URLS.host + String.format(URLS.samlConfigURL, globalConfig.customer.id);
			return $http.post(samlConfigURL, samlProfile)
				.then(createSamlProfile, handleError);

			function createSamlProfile(response) {
				return response;
			}
		}
		

		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 412 || error.status === 409 || error.status === 400) {
				return error.data.reason;
			}
			return 'Unknown server error';
		}

	}
})();
